export default {
  dashboard: 'Dashboard',
  heartPulse: 'HP',
  SPO2: 'SPO2',
  falling: 'Falling',
  pulseRate: 'PR',
  temperature: 'Temp',
  state: 'State',
  charge: 'Charge',
  warningType: 'Warning Type',
  warnings: 'Warnings',
  standing: 'Standing',
  laying: 'Laying',
  ecg: 'ECG',
  callNotAnswer: 'CNA',
  history: 'History',
  online: 'Realtime',
  showHistory: 'Show history',
  bloodPressure: 'BP',
  map: 'Map',
  off: 'Off',
  warningTypesInfo: {
    FALLING: 'Falling',
    CALL_NO_ANSWER: 'Call no answer',
    HIGH_HEART_RATE: 'High Heart Rate',
    LOW_HEART_RATE: 'Low Heart Rate',
    HIGH_PULSE_RATE: 'High Pulse Rate',
    LOW_PULSE_RATE: 'Low Pulse Rate',
    HIGH_HEART_PULSE: 'High Heart Pulse',
    LOW_HEART_PULSE: 'Low Heart Pulse',
    HIGH_TEMPERATURE: 'High Temperature',
    LOW_TEMPERATURE: 'Low Temperature',
    HIGH_SPO2: 'High SPO2',
    LOW_SPO2: 'Low SPO2',
    UNDEFINED: 'Undefined'
  }
}
